import React from "react";
import Chart from "react-apexcharts";

export default function SkillChart({ data }) {
  console.log(data);

  const newColors = [
    { label: "Master", color: "#28A745" },
    { label: "Competent", color: "#508FD6" },
    { label: "Learner", color: "#EC930D" },
    { label: "Novice", color: "#EAD51A" },
    { label: "NA", color: "#A52A2A" },
  ];
  const series =
    data.length > 0
      ? [
          { name: "Master", data: data.map((d) => d.masterCount) },
          { name: "Competent", data: data.map((d) => d.competentCount) },
          { name: "Learner", data: data.map((d) => d.learnerCount) },
          { name: "Novice", data: data.map((d) => d.noviceCount) },
          { name: "N/A", data: data.map((d) => d.notApplicableCount) },
        ]
      : [];

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      parentHeightOffset: 0,
      animations: {
        enabled: false, // 👈 disable animation for smoother scroll
      },
    },
    noData: {
      text: "No data available", // 👈 message when no series
      align: "center",
      verticalAlign: "middle",
      style: {
        fontSize: "14px",
        color: "#000000",
      },
    },
    fill: {
      opacity: 1, // 👈 full solid color
    },
    plotOptions: {
      bar: {
        horizontal: true, // 👈 horizontal layout
        borderRadius: 0,
        barHeight: "20px",
      },
    },
    xaxis: {
      categories: data?.map((d) => d.skillName), // 👈 skills on Y-axis
      position: "top",
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
      floating: false, // 👈 ensures it's outside the plot
      offsetY: -45, // 👈 push legend down a bit
    },
    grid: {
      yaxis: {
        lines: { show: false }, // removes extra grid lines
      },
      row: {
        colors: ["transparent"], // 👈 removes alternate row shading (separators)
        opacity: 0,
      },
    },
    tooltip: {
      enabled: false, // 👈 completely hide tooltip
    },
    colors: newColors.map((c) => c.color),
  };

  return (
    <div
      style={{
        height:
          data?.length == 1
            ? 110
            : data?.length <= 3
            ? data?.length * 65
            : data?.length * 40,
      }}
    >
      {console.log(data?.length, "len")}
      {data.length > 0 ? (
        <Chart
          options={options}
          series={series}
          type="bar"
          width="100%"
          height="100%"
        />
      ) : (
        <div className="noData d-flex align-items-center justify-content-center mt-4">
          No data available
        </div>
      )}
    </div>
  );
}
